<template>

    <div class="my-quizzes-mechanisms">
        <div class="title">{{ t.__('Mechanizmy') }}:</div>
        <div class="elements">
            <div class="element" @click="showMechanisms('assoc')">
                <img src="/assets/images/association-icon.png" class="icon" alt="">
                <div class="name">{{ t.__('Skojarzenia') }}</div>
            </div>
            <div class="element" @click="showMechanisms('carousel')">
                <img src="/assets/images/carousel-icon.png" class="icon" alt="">
                <div class="name">{{ t.__('Karuzela pytań') }}</div>
            </div>
            <div class="element" @click="showMechanisms('qball')">
                <img src="/assets/images/qball-icon.png" class="icon" alt="">
                <div class="name">{{ t.__('Piłka nożna - quiz') }}</div>
            </div>
            <div class="element" @click="showMechanisms('ships')">
                <img src="/assets/images/ships-icon.png" class="icon" alt="">
                <div class="name">{{ t.__('Statki') }}</div>
            </div>
        </div>
    </div>

</template>

<script>

export default {

    name: 'MyQuizzesLegend',

    data() {
        return {
            eventHub: window.eventHub
        }
    },

    methods: {

        showMechanisms(mechanism) {
            this.eventHub.$emit('my-quizzes-show-mechanisms', mechanism);
        }

    }

}
</script>

<style scoped>

</style>
